import { useEffect } from 'react';
import { useParticipants, useVideoContext } from '../../main';
import { BeaconChatData, DatatrackDataTypes } from '../../types/DatatrackTypes';
export default function DataTrack({ track }) {
    const { room, addChatMsg } = useVideoContext();
    const participants = useParticipants();
    useEffect(() => {
        if (room.state === 'connected') {
            /**
             * Handler for track message event which currently only identifies chat messages and updates the chatLog.
             * Possible refactor point here where we could create a separate utility that is used to identify & type
             * received messages. In addition the chat specific logic could be moved to a chat specific context and
             * made a function call to keep this component more manageable.
             * @param data any
             */
            const handleDataTrackMessage = (data) => {
                // TODO: properly identify type here (similar to how it's done in virtual)
                const msgObj = JSON.parse(data);
                if (msgObj.type === DatatrackDataTypes.Chat) {
                    const trackParticipant = participants.find((participant) => {
                        // @ts-ignore - this is baloney. sid does exist on remote datatracks
                        return participant.dataTracks.has(track.sid);
                    });
                    const isHost = trackParticipant === null || trackParticipant === void 0 ? void 0 : trackParticipant.identity.startsWith('host');
                    msgObj.ishost = isHost;
                    // We are already adding the isHost property on the sending side which technically could be used instead
                    // of recreating the msgObj here. However this guards against someone receiving a message from an attendee
                    // that is not the host with the isHost property set to true
                    const updatedMsg = new BeaconChatData(msgObj.msg, msgObj.user, msgObj.sid, isHost);
                    addChatMsg(updatedMsg);
                }
            };
            track.on('message', handleDataTrackMessage);
            return () => {
                track.off('message', handleDataTrackMessage);
            };
        }
    }, [track, addChatMsg]);
    return null;
}
//# sourceMappingURL=DataTrack.js.map